<template>
  <span style="display:inline-block;">
    <!-- ── Tooltip ------------------------------------------------------- -->
    <div v-if="showTooltip" class="mytooltip">
      <span class="mytooltip-text">{{ tooltip }}</span>
    </div>

    <!-- ── Icon button --------------------------------------------------- -->
    <a
      class="btn btn-icon btn-light btn-sm mem-btn"
      @click.prevent="handleClick"
      @mouseenter="showTooltip = true"
      @mouseleave="showTooltip = false"
    >
      <span class="svg-icon svg-icon-md svg-icon-primary-blue">
        <!-- font‑icon OR inline‑svg, one of them will render -->
        <i v-if="icon" :class="icon"></i>
        <inline-svg v-else-if="svg" :src="svg"></inline-svg>
      </span>
    </a>
  </span>
</template>

<script>
export default {
  name  : 'MemlistIconButton',
  props : {
    icon   : { type:String, default:null }, // e.g. 'fas fa-star'
    svg    : { type:String, default:null }, // path or import to .svg file
    tooltip: { type:String, default:'' }
  },
  emits : ['click'],
  data  : () => ({
    showTooltip: false
  }),
  methods: {
    handleClick () {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/components/forms/_memlist_tooltip.scss";

/* ───── Tooltip box ─────────────────────────────────────────────────── */
.mytooltip {
  position: absolute;
  z-index:99999;
}
.mytooltip-text {
  position: absolute;
  left:50%; top:-37px;
  width:160px; margin-left:-80px;
  z-index:99999;
  background:#fff;
  border:1px solid #3699ff;
  padding:5px; border-radius:8px;
  text-align:center;
  overflow:hidden; text-overflow:ellipsis;
}

/* ───── Button hover colour (CSS – no JS needed) ────────────────────── */
.mem-btn          { transition:background-color .15s; }
.mem-btn:hover    { background-color:lightblue; }

/* ───── Make sure SVG never captures the mouse pointer ──────────────── */
.mem-btn .svg-icon,
.mem-btn .svg-icon * { pointer-events:none; }

/* ───── Brand‑blue helper for inline SVGs using `currentColor` ──────── */
.svg-icon-primary-blue,
.svg-icon-primary-blue * {
  color:#3699FF !important;
  fill:currentColor !important;   /* inline‑svg paths follow the colour */
}
</style>
